
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Project, Photo } from '../types';

interface PhotoUploadModalProps {
  tempPhotoUrl: string | null;
  project: Project;
  onSave: (data: Partial<Photo>) => void;
  onClose: () => void;
  actionLoading: boolean;
}

export const PhotoUploadModal: React.FC<PhotoUploadModalProps> = ({ 
  tempPhotoUrl, project, onSave, onClose, actionLoading 
}) => {
  const [formData, setFormData] = useState({
    description: '',
    room: 'Geral',
    stageId: project.stages[0]?.id || ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn" onClick={onClose}>
       <div className="bg-white dark:bg-slate-950 w-full max-w-md rounded-[2.5rem] overflow-hidden shadow-2xl flex flex-col max-h-[90vh]" onClick={e => e.stopPropagation()}>
          <div className="h-64 sm:h-auto sm:aspect-square bg-black relative shrink-0">
             <img src={tempPhotoUrl || ''} className="w-full h-full object-contain" alt="Preview" />
             <button onClick={onClose} className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-full backdrop-blur-md"><X size={20}/></button>
          </div>
          <form onSubmit={handleSubmit} className="p-6 space-y-4 overflow-y-auto">
             <div>
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1 block">Ambiente / Local</label>
                <input required className="w-full bg-slate-50 dark:bg-slate-900 p-3 rounded-xl font-bold outline-none focus:ring-2 focus:ring-emerald-500" value={formData.room} onChange={e => setFormData({...formData, room: e.target.value})} placeholder="Ex: Sala de Estar" />
             </div>
             <div>
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1 block">Etapa Relacionada</label>
                <select className="w-full bg-slate-50 dark:bg-slate-900 p-3 rounded-xl font-bold outline-none focus:ring-2 focus:ring-emerald-500" value={formData.stageId} onChange={e => setFormData({...formData, stageId: e.target.value})}>
                   {project.stages.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                </select>
             </div>
             <div>
                <label className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1 block">Descrição / Obs</label>
                <textarea className="w-full bg-slate-50 dark:bg-slate-900 p-3 rounded-xl font-bold outline-none focus:ring-2 focus:ring-emerald-500 resize-none h-20" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} placeholder="O que foi feito?" />
             </div>
             <button type="submit" disabled={actionLoading} className="w-full bg-emerald-600 text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-emerald-700 shadow-lg shadow-emerald-600/20">
                {actionLoading ? 'Enviando...' : 'Salvar Foto'}
             </button>
          </form>
       </div>
    </div>
  );
};
